import { compact, isEmpty } from 'lodash'

import constants from 'constants/index'

const plotFlowchartData = (dataProcess) => {
  return [
    {
      name: 'Origem dos Dados',
      children: sources(dataProcess?.dataProcessDataSources),
      textColor: 'black',
      type: 'event',
    },
    {
      name: 'Compartilhamento',
      children: storage(dataProcess?.dataTreatments),
      color: 'purple',
      textColor: 'purple',
      type: 'annotation',
    },

    {
      name: 'Ativos',
      children: location(dataProcess?.lifeCycles),
      color: 'blue',
      textColor: 'blue',
      type: 'annotation',
    },
    {
      name: 'Disposição',
      children: arranged(dataProcess?.lifeCycles),
      color: 'red',
      textColor: 'red',
      type: 'annotation',
    },
    {
      name: 'Fim',
      type: 'event',
      textColor: 'black',
    },
  ]
}

const sources = (dataProcessDataSources) => {
  const { SOURCES_WITH_ENTITY, TITULAR_DESCRIPTION } = constants.dataProcess

  if (isEmpty(dataProcessDataSources)) {
    return []
  }

  const options = []

  dataProcessDataSources.forEach((dataProcessDataSource) => {
    const hasEntitySources = SOURCES_WITH_ENTITY.includes(
      dataProcessDataSource?.sourceDescription,
    )
    const hasValidSources = !isEmpty(dataProcessDataSource?.dataProcessSources)

    if (hasEntitySources && hasValidSources) {
      const sourcesWithContext = dataProcessDataSource.dataProcessSources.map(
        (source) => {
          const contextPrefix =
            source?.type === 'Department' ? 'Departamento: ' : ''
          return { name: `${contextPrefix}${source?.name}` }
        },
      )

      options.push(...sourcesWithContext)
    } else if (
      dataProcessDataSource?.sourceDescription === TITULAR_DESCRIPTION
    ) {
      options.push({ name: 'O próprio titular' })
    } else {
      options.push({ name: dataProcessDataSource?.sourceDescription })
    }
  })

  return options
}

const storage = (dataTreatments) => {
  if (isEmpty(dataTreatments)) return []

  const sharedProcesses = dataTreatments?.map((dataTreatment) => {
    return { name: dataTreatment?.shareProcess?.name }
  })

  return compact(sharedProcesses || [])
}

const location = (lifeCycles) => {
  if (isEmpty(lifeCycles)) return []

  const assetInventories = lifeCycles?.map((lifeCycle) => {
    if (lifeCycle?.assetInventory?.name) {
      return { name: lifeCycle?.assetInventory?.name, type: 'data' }
    }
  })

  return compact(assetInventories || [])
}

const arranged = (lifeCycles) => {
  if (isEmpty(lifeCycles)) return []

  const discardModes = lifeCycles?.map((lifeCycle) => {
    if (lifeCycle?.discardMode?.name) {
      return { name: lifeCycle?.discardMode?.name }
    }
  })

  return compact(discardModes || [])
}

export default plotFlowchartData
